import api from 'src/configs/api';
import { TOption, TRequestOption } from 'src/types/Commons/option.model';
import qs from 'qs';
import { TBaseResponse } from 'src/types/Commons/filter.model';

const prefix = 'api/common';

export const getAppInfo = async () => {
  const res = await api.get(`/info`);
  return res.data;
};

export const getDataOption = async (param: TRequestOption) => {
  try {
    const query = qs.stringify(param);
    const res = await api.get<TBaseResponse<TOption[]>>(`${prefix}/data-option?${query}`);
    return res.data;
  } catch (_) {
    return {data:[] as TOption[]} as TBaseResponse<TOption[]>
  }
};

export const getMenuCategories = async () => {
  try {
    const res = await api.get(`${prefix}/menus`);
    if (res.data.succeeded) {
      return res.data.data;
    }
    return [];
  } catch (_) {
    return [];
  }
};
